module.exports = __webpack_public_path__ + "static/media/truck-lg.fc7059b5.png";